module.exports = __webpack_public_path__ + "static/placesapp-37c1e5a3322a8b2b67d9ed5eeab2085b.jpeg";